module.exports = __webpack_public_path__ + "distribution/img/xitong.9bdce74a.png";